import { render, staticRenderFns } from "./medicalReport.vue?vue&type=template&id=7f028563&scoped=true&"
import script from "./medicalReport.vue?vue&type=script&lang=js&"
export * from "./medicalReport.vue?vue&type=script&lang=js&"
import style0 from "./medicalReport.vue?vue&type=style&index=0&id=7f028563&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f028563",
  null
  
)

component.options.__file = "medicalReport.vue"
export default component.exports